<button (click)="expand = !expand" title="{{tooltip}}">{{label}}</button>
<span *ngIf="expand"><ng-content></ng-content></span>
